import React, { useState } from 'react'
import { Typography, Button, Box } from '@material-ui/core'
import { PlusCircle as PlusCircleIcon } from 'react-feather'

import { BaseDialog, MenuButton, Permitted } from 'components'
import NewForm from './NewForm'

import useDataTreatment from 'hooks/useDataTreatment'
import useSnackbar from 'hooks/useSnackbar'
import useDataProcessOptions from 'hooks/useDataProcessOptions'

import DataProcessTemplateQuestionProvider from 'providers/DataProcessTemplateQuestionProvider'
import theme from 'theme'

const DataTreatmentModal = ({ dataTreatment, mode, children }) => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const snackbar = useSnackbar()
  const dataTreatmentHook = useDataTreatment()
  const { dataProcessTemplate } = useDataProcessOptions()

  const edit = mode === 'edit'
  const isShow = mode === 'show'

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const reloadData = () => dataTreatmentHook.loadData('')

  const submitSuccess = () => {
    snackbar.open({
      message: `Compartilhamento de dados ${
        edit ? 'atualizados' : 'criado'
      } com sucesso`,
      variant: 'success',
    })
    handleClose()
    reloadData()
  }

  return (
    <>
      {edit ? (
        <Permitted tag="create_data_process">
          <MenuButton>
            <Button color="secondary" fullWidth onClick={handleOpen}>
              Editar
            </Button>
            {children}
          </MenuButton>
        </Permitted>
      ) : (
        <Permitted tag="create_data_process">
          <Button
            onClick={handleOpen}
            variant="outlined"
            startIcon={<PlusCircleIcon size={20} />}
            size="small"
          >
            <Typography>Adicionar compartilhamento de dados</Typography>
          </Button>
        </Permitted>
      )}
      <BaseDialog
        open={open}
        setOpen={setOpen}
        dialogSize="lg"
        title={`${edit ? 'Editar' : 'Adicionar'} compartilhamento de dados`}
        dialogActions={
          <Box
            display="flex"
            justifyContent="flex-end"
            width="100%"
            gridGap={theme.spacing(1)}
          >
            <Button
              type="button"
              variant="outlined"
              color="secondary"
              onClick={handleClose}
            >
              Voltar
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading || isShow}
              form="shared-data-treatment-form"
            >
              {loading ? 'Aguarde...' : 'Salvar'}
            </Button>
          </Box>
        }
      >
        <DataProcessTemplateQuestionProvider
          dataProcessTemplate={dataProcessTemplate}
          step="data_treatment"
          dataProcessTemplateAnswers={
            dataTreatment?.dataProcessTemplateAnswers || []
          }
        >
          <NewForm
            mode={mode}
            dataTreatment={dataTreatment}
            submitSuccess={submitSuccess}
            setLoading={setLoading}
          />
        </DataProcessTemplateQuestionProvider>
      </BaseDialog>
    </>
  )
}

export default DataTreatmentModal
